const NavigationRight = ({ ...props }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="a" />
      <g id="b">
        <polygon points="9.5 16 9.5 8 14.5 12 9.5 16" />
      </g>
    </svg>
  )
}

export default NavigationRight
